import { ReactElement } from 'react';
import { SingleValueChart } from './single-value-chart';
import { useAnalyticsTranslation } from '../hooks';
import { useTasksAndAlertsAnalytics } from '../providers/tasks-and-alerts-analytics-provider';

export function TotalAlertsChart(): ReactElement {
    const { t } = useAnalyticsTranslation();
    const { totalAlertsData, status } = useTasksAndAlertsAnalytics();

    return (
        <SingleValueChart
            title={t('components.total_alerts_chart.title')}
            description={t('components.total_alerts_chart.description')}
            value={totalAlertsData?.value}
            dateString={totalAlertsData?.dateString}
            loading={status === 'pending'}
            error={status === 'error'}
        />
    );
}
